module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "label": "类型",
      "placeholder": "请选择售后类型",
      "value": _vm.formData.title,
      "error": _vm.formValidate && !_vm.formData.title,
      "readonly": "",
      "input-align": "right"
    },
    on: {
      "click": _vm.showTypeSelect
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "问题描述",
      "placeholder": "请输入详细的问题描述",
      "input-align": "right",
      "value": _vm.formData.note,
      "error": _vm.formValidate && !_vm.formData.note
    },
    on: {
      "input": _vm.writeDescr
    },
    model: {
      value: (_vm.descr),
      callback: function($$v) {
        _vm.descr = $$v
      },
      expression: "descr"
    }
  })], 1), _vm._v(" "), _c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.pics,
      "limit": 9,
      "name": 'pics'
    },
    on: {
      "imageListChange": _vm.imageListChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [(!_vm.loading) ? _c('van-button', {
    attrs: {
      "type": "danger",
      "size": "large",
      "round": ""
    },
    on: {
      "click": _vm.formSave
    }
  }, [_vm._v("确定")]) : _c('van-button', {
    attrs: {
      "type": "danger",
      "size": "large",
      "round": ""
    }
  }, [_vm._v("确定中...")])], 1), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.selectShow),
      callback: function($$v) {
        _vm.selectShow = $$v
      },
      expression: "selectShow"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "title": "标题",
      "columns": _vm.columns
    },
    on: {
      "cancel": _vm.onCancel,
      "confirm": _vm.onConfirm
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87fd9432","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/order/ServiceApply.vue
// module id = 2534
// module chunks = 0